import { render, staticRenderFns } from "./ButtonLogo.vue?vue&type=template&id=d2ceb844&"
import script from "./ButtonLogo.vue?vue&type=script&lang=js&"
export * from "./ButtonLogo.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports